import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useSessionStore } from 'session/useSessionStore';
import { CognitoSecureRoute } from './CognitoSecureRoute';
import { GeopostSecureRoute } from './GeopostSecureRoute';
import { OktaSecureRoute } from './OktaSecureRoute';

export const SecureRoute = () => {
    const tenantConfig = useSessionStore(state => state.tenantConfiguration);

    useEffect(() => {
        console.log(tenantConfig);
    }, [tenantConfig]);

    return (
        !!tenantConfig?.oktaAuthConfiguration ?
            <OktaSecureRoute/>
            :
            !!tenantConfig?.cognitoAuthConfig ?
                <CognitoSecureRoute/>
                :
                <GeopostSecureRoute/>
    );
};